import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Shipping1, Gift } from 'baby-design/icons'

import { shipmentViewPath } from 'lib/urls'

import NavigationCard from 'src/routes/(registry)/shipments/components/NavigationCard'

import styles from './NavFooter.styles.scss'

const ShippingCallout: FC = () => {
  const graphicIcon = <Shipping1 className={styles.NavFooter__ShippingIcon} />

  return (
    <NavigationCard
      bodyCopy="See what's on the way from the Babylist Shop."
      buttonHref={shipmentViewPath}
      graphicIcon={graphicIcon}
      headline="Shipments"
      testid="NavFooter__ShippingCallout"
    />
  )
}

const RegistryCallout: FC<{ registryUrl: string | undefined }> = ({
  registryUrl,
}) => {
  const graphicIcon = <Gift className={styles.NavFooter__RegistryIcon} />

  return (
    <NavigationCard
      bodyCopy="Manage gifts you've requested from friends & family."
      buttonHref={registryUrl || ''}
      graphicIcon={graphicIcon}
      headline="Registry"
      testid="NavFooter__RegistryCallout"
    />
  )
}

export type NavFooterProps = {
  registryUrl: string | undefined
}
const NavFooter: FC<NavFooterProps> = ({ registryUrl }) => (
  <div className={styles.NavFooter}>
    <ShippingCallout />
    <RegistryCallout registryUrl={registryUrl} />
  </div>
)

export default NavFooter
